const TIMEFRAMES = new Map([
  ["1m", "1m"], ["1 min", "1m"], ["1 minute", "1m"],
  ["5m", "5m"], ["5 min", "5m"], ["5 minute", "5m"], ["5 minutes", "5m"],
  ["15m", "15m"], ["15 min", "15m"], ["15 minute", "15m"], ["15 minutes", "15m"],
  ["30m", "30m"], ["30 min", "30m"], ["30 minute", "30m"], ["30 minutes", "30m"],
  ["1h", "1h"], ["1 hour", "1h"], ["1 hours", "1h"],
  ["4h", "4h"], ["4 hour", "4h"], ["4 hours", "4h"],
  ["1d", "1d"], ["1 day", "1d"], ["1 days", "1d"],
]);

const canonicalSymbol = value => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");

function parseTimeframe(text) {
  const match = text.match(/^(?:please\s+)?(?:(?:set|change|switch)\s+(?:the\s+)?(?:chart\s+)?(?:time\s?frame|interval)(?:\s+to)?\s+|(?:switch|set)\s+charts?\s+to\s+)?(.+?)(?:\s+charts?)?$/i);
  if (!match) return null;
  const value = match[1].toLowerCase().replace(/\s+/g, " ").trim();
  const timeframe = TIMEFRAMES.get(value);
  return timeframe ? { type: "set_chart_timeframe", timeframe } : null;
}

function parseLayout(text) {
  const match = text.match(/^(?:please\s+)?(?:(?:switch|set|change)\s+(?:the\s+)?chart\s+(?:layout|view)\s+to\s+|(?:open|show)\s+)?(single|dual|double|split|quad|four)(?:\s+(?:chart|charts|view|layout))?$/i);
  if (!match) return null;
  const layout = ({ double: "dual", split: "dual", four: "quad" })[match[1].toLowerCase()] || match[1].toLowerCase();
  return { type: "set_chart_layout", layout };
}

function parseChartSymbols(text, allowedSymbols) {
  if (!Array.isArray(allowedSymbols) || !allowedSymbols.length) return null;
  const match = text.match(/^(?:please\s+)?(?:chart\s+|show(?:\s+me)?\s+|open\s+charts?\s+(?:for\s+)?|switch\s+charts?\s+to\s+|set\s+charts?\s+to\s+|display\s+)(.+?)(?:\s+on\s+charts?)?$/i);
  if (!match) return null;
  const requested = match[1].split(/\s*(?:,|\band\b)\s*/i).map(s => s.trim()).filter(Boolean);
  if (!requested.length || requested.length > 4) return null;

  const byCanonical = new Map(allowedSymbols.map(symbol => [canonicalSymbol(symbol), symbol]));
  const symbols = requested.map(symbol => byCanonical.get(canonicalSymbol(symbol)));
  if (symbols.some(symbol => !symbol)) return null;
  return { type: "set_chart_symbol", symbols };
}

/** Parse high-confidence chart utterances that should not wait for an LLM turn. */
export function parseVoiceFastChartIntent(transcript, allowedSymbols = []) {
  const text = String(transcript || "").trim().replace(/[.!?]+$/, "").replace(/\s+/g, " ");
  if (!text) return null;
  return parseTimeframe(text) || parseLayout(text) || parseChartSymbols(text, allowedSymbols);
}
